module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan hanche.1f9fd1e4.svg";